import { createFileRoute } from '@tanstack/react-router'
import { PartnerRouteGuard } from '../../components/PartnerRouteGuard'
import { OrganizationSettingsPage } from '../../components/OrganizationSettingsPage'

export const Route = createFileRoute('/partner/settings')({
  component: () => {

    return (
      <PartnerRouteGuard>
        <OrganizationSettingsPage />
      </PartnerRouteGuard>
    )
  },
})
